import React, { useEffect, useState } from 'react';
import { Box, Typography, Stack, Button, Avatar, Card, IconButton } from "@mui/material";
import { useParams, useHistory } from "react-router-dom";
import { Images } from "./../../assets/common";
import './MusicDetailsCard.scss';
import Movie from "../../assets/common/resources/Movie.svg";
import musicnote from "../../assets/common/resources/musicnote.svg";
import Trendup from "../../assets/common/resources/Trendup.svg";
import copypclip from "../../assets/common/resources/copypclip.svg";
import tipcolor from "../../assets/common/resources/tipcolor.svg";
import coin_icon from "../../assets/common/resources/coin_icon.svg";


import {
  onShare,
  copyToClipboard,
  getUserDetail,
  generateDynamicLink,
  fullName,
} from "./../../constants/function";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";  // Import the copy icon

import IosShareIcon from "@mui/icons-material/IosShare";
import PropTypes from 'prop-types';
import DropDown from "../../components/DropDown";
import ApiService from '../../services/api-service';
import ProfileMenu from "../../components/ProfileMenu";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import OutsideClickHandler from "react-outside-click-handler";
import StudIcon from "../../assets/common/resources/StudIcon.svg";
import UploadVideoPopup from '../../components/VideoUpload/UploadVideoPopup';
import { data } from '../../components/BarGraph/bardata';
import VideoPlayer from "../../components/VideoPlayer";





// Helper function to format large numbers (e.g., 1k, 2.5k)
const kFormatter = (num) => {
  if (Math.abs(num) > 999) {
    return Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k';
  }
  return Math.sign(num) * Math.abs(num);
};

const MusicDetailsCard = ({
  gif,
  music,
  video,
  playListId,
  title,
  fullName,
  t,
  listens,
  owner,
  setOpenTip,
  playAll,
  handleClick,
  option,
  isOwnerId,
  createdBy,
  activeTab,
  menuKey,
  setMenuKey,
  nftDetails,
  setIsStreamingPopup,
  handleTabChange,
  setTipOrStream,
  tipOrStream,
  createdByDetails,
  selectedVideo,
  live,
}) => {
  const [topFiveTippers, setTopFiveTippers] = useState([]);
  const [topFiveStreamers, setTopFiveStreamers] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);
  const [showUploadPopup, setShowUploadPopup] = useState(false);  // State to manage popup visibility
  const userDetail = getUserDetail();

  const widthArray = ["100%", "90%", "80%", "70%", "60%"];

  const [showShareMenu, setShowShareMenu] = useState(false);





// Function to calculate the total duration in hours and minutes
const getTotalDuration = (playlist) => {
  const totalDurationInSeconds = playlist.reduce((acc, song) => acc + (song.duration || 0), 0);

  const hours = Math.floor(totalDurationInSeconds / 3600);
  const minutes = Math.floor((totalDurationInSeconds % 3600) / 60);

  return `${hours ? `${hours}hr ` : ''}${minutes}mins`;
};

const PlaylistInfo = ({ playlist }) => {
  return (
    <Box display="flex" alignItems="center">
      <Typography variant="h6" sx={{ fontWeight: 600, marginRight: '8px' }}> {/* Semibold for song count */}
        {`${playlist.length} Songs`}
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 300 }}> {/* Thin font for duration */}
        {getTotalDuration(playlist)}
      </Typography>
    </Box>
  );
};  



  // Handle copy and share actions
  const handleCopy = async (action) => {
    const thumbnail = gif || (music.length > 0 && music[0]?.thumbnailImg?.filePath) || Images.album;
    const url = await generateDynamicLink('studio', playListId, title, '', thumbnail);


    switch (action) {
      case "copy":
        copyToClipboard(url);
        alert(t("linkCopied"));  // Or use notifier for better UI feedback
        break;
      case "twitter":
        onShare('twitter', url, { sharedBy: 'User', socialMedia: 'twitter' });
        break;
      case "facebook":
        onShare('facebook', url, { sharedBy: 'User', socialMedia: 'facebook' });
        break;
      default:
        break;
    }
  };

const handleShare = async (socialPlatform) => {
  try {
    const thumbnail = gif || (music.length > 0 && music[0]?.thumbnailImg?.filePath) || Images.album;
    const url = await generateDynamicLink('studio', playListId, title, '', thumbnail);

    // Social sharing logic (onShare function is used)
    onShare(socialPlatform, url, {
      id: createdBy,
      referralLink: url,
      eventType: ["sharedOutbound"],
      eventAsset: playListId,
      sharedBy: fullName({ firstName: "User", lastName: "Example" }), // Replace with actual user details
      eventValue: ["Studio"],
      socialMedia: socialPlatform,
    });
  } catch (error) {
    console.error("Share failed", error);
  }
};

const fetchTopFiveTippers = async (playListId) => {
  setLoading(true);
  try {
    const data = await ApiService.GET_PLAYLIST_MOST_TIPPED(`playlistId=${playListId}`);
    console.log('Tippers Data:', data); // Inspect response structure

    // Assuming `data.result` contains an array of tippers, each with user profile data and tip amount
    const topTippers = data.result.map((tipper) => ({
      profileImg: tipper.profilePic?.filePath || '', // Safely accessing profilePic.filePath
      fullName: tipper.fullName || 'Unknown User', // Default name if missing
      id: tipper._id, // User ID for profile links
    }));

    console.log('Mapped Top Tippers:', topTippers); // Log the mapped tippers


    setTopFiveTippers(topTippers);
    setLoading(false);
  } catch (error) {
    console.error("Error fetching top tippers", error);
    setLoading(false);
  }
};
useEffect(() => {
  console.log('Updated Top Five Tippers State:', topFiveTippers);
}, [topFiveTippers]);
  const getTopFiveMostStreamed = async (playListId) => {
    setLoading(true);
    try {
      const response = await ApiService.GET_PLAYLIST_MOST_STREAMED(`playlistId=${playListId}`);
      setTopFiveStreamers([...response.result]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (playListId) {
      getTopFiveMostStreamed(playListId);

      fetchTopFiveTippers(playListId);
    }
  }, [playListId]);

  return (
    <Stack
      className={`music-details-card ${activeTab === 'Video' ? 'active' : ''}`}
      direction={{ xs: 'column', md: 'row' }}
      sx={{ justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
    >
      {/* Image */}
      <Box
        className={`thumbnail-box ${activeTab === 'Video' ? 'video-active' : ''}`}
        sx={{
          position: 'relative',
          width: '200px',
          height: '200px',
        }}
      >
        {/* Apply blur only to the image, not its container */}
        <Box
          component="img"
          className="_img_medium br16"
          src={gif || (music.length > 0 ? music[0]?.thumbnailImg?.filePath : "")}
          alt="music"
          sx={{
            width: '100%',
            height: 'auto',
            filter: activeTab === 'Video' ? 'brightness(0.5) blur(3px)' : 'none', // Blur effect only on image
            transition: 'all 0.5s ease',
          }}
        />
        <Typography
          className="listen-count"
          sx={{
            color: '#fff',
            textAlign: 'center',
            marginTop: '8px',
            fontSize: '14px',
          }}
        >
          {t("analytics.card.card3")}: {listens || 0}
        </Typography>
        </Box>
  
        {/* Content box and buttons, only in Video tab */}
        {activeTab === 'Video' && (
          <Stack
            direction="column"
            spacing={2}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '4%', // Shifted left to overlay on the thumbnail
              transform: 'translateY(-50%)',
              zIndex: 1, // Ensure text and buttons are above the blurred image
              color: '#fff',

              textAlign: 'center',
            }}
          >
          <Typography 
            sx={{ 
              fontSize: '30px',  // Set font size to 30px
              fontWeight: '700', // Keep the font weight
              fontFamily: 'Inter, sans-serif', // Specify Inter font
              display: 'inline-flex', // Use inline-flex to ensure the image and text are aligned
              alignItems: 'center', // Align text and image vertically
              justifyContent: 'center', // Center the text and the image
              width: '100%',  // Ensure full width to center title


            }}
          >
            {title || t("myMusic.title")}
          </Typography>
  
  
            {/* Uploader Info */}
            <Stack direction="row" alignItems="center" spacing={1} 
            sx={{ 
                marginTop: '4px',  // Small margin to space uploader info from playlist info
                paddingLeft: '0px',  // No padding so it aligns with the start of playlist info
                justifyContent: 'center'  // Align uploader info to the start
              }}
            >
                <Avatar
                src={createdByDetails?.profileImg?.filePath || Images.dummy1}
                alt={createdByDetails?.displayArtistName}
                sx={{ width: 20, height: 20 }}
              />
              <Typography className="uploader-name" sx={{ fontSize: '12px', color: '#ffffff' }}>
              Created by {createdByDetails?.displayArtistName || "Unknown Artist"}
              </Typography>
            </Stack>
  
            {/* Buttons: Music, Share, Analytics, Tip, Live, Upload */}
            <Stack direction="row" gap="0px" alignItems="center">
              {/* Music Button */}
              <IconButton
                className="Music-button"
                onClick={() => handleTabChange("Music")}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: '10px',
                  width: '30px',
                  height: '30px',
                  backgroundColor: activeTab === 'Music' ? '#FFee20' : '#FFFFFF',
                  '&:hover': {
                    backgroundColor: activeTab === 'Music' ? '#f0f0f0' : '#FFdd00',
                  },
                }}
              >
                <img src={musicnote} alt="music" style={{ width: '15px', height: '15px' }} />
              </IconButton>
  
              {/* Share Button */}
              <IconButton className="share-button" onClick={() => setShowShareMenu(!showShareMenu)}>
                <img src={copypclip} alt="copy" style={{ width: '20px', height: '20px' }} />
              </IconButton>
  
              {/* Analytics Button */}
              {playListId && (
                <IconButton
                  className="analytics-button"
                  sx={{ width: "40px", height: "40px" }}
                  color="default"
                  onClick={() => history.push(`/app/PlaylistStatics/${playListId}/${createdBy}`)}
                >
                  <img src={Trendup} alt="analytics" style={{ width: '20px', height: '20px' }} />
                </IconButton>
              )}
  
              {/* Tip Button */}
              {playListId && (
                <IconButton className="tip-button" title="Tip studio" onClick={() => setOpenTip(true)}>
                  <img src={tipcolor} alt="tip" style={{ width: '20px', height: '20px', marginTop: '3px' }} />
                </IconButton>
              )}
  
              {/* Live Streaming Button */}
              {isOwnerId(owner) && !live && playListId && !nftDetails?.onAuction && !nftDetails?.onSale ? (
                <IconButton className="_playlist_streaming_camera" onClick={() => setIsStreamingPopup(true)}>
                  <img title="Open live streaming" style={{ width: "15px", marginTop: '3px' }} src={Images.streaming_filled} alt="camera" />
                </IconButton>
              ) : !isOwnerId(owner) && playListId && live ? (
                <IconButton className="_playlist_streaming_camera" onClick={() => handleJoin()}>
                  <img title="Open live streaming" style={{ width: "15px", marginTop: '3px' }} src={Images.streaming_filled} alt="camera" />
                </IconButton>
              ) : null}
  
            {/* Upload Video Button (only if the current user is the owner) */}
            {isOwnerId(owner) && (
              <Box sx={{ marginBottom: '3px', marginLeft: '5px' }}>
                <IconButton
                  variant="contained"
                  color="primary"
                  onClick={() => setShowUploadPopup(true)}
                  sx={{
                    padding: 0,  // Remove padding to make the button fit the image size exactly
                    minWidth: 'auto',  // Prevent the button from having default minimum width
                  }}
                >
                  <img
                    src={Images.upload_home}
                    alt="Upload Video"
                    style={{
                      width: '20px',
                      height: '20px',
                      marginLeft: '5px'
                    }}
                  />
                </IconButton>
              </Box>
            )}
            {/* UploadVideoPopup integration */}
            {isOwnerId(owner) && (
                    <UploadVideoPopup
                      open={showUploadPopup}
                      onClose={() => setShowUploadPopup(false)}
                      studioId={playListId}  // Pass the playlist ID as the studio ID for the upload
                      onSuccess={(data) => console.log('Video uploaded successfully', data)}
                      onError={(error) => console.error('Video upload failed', error)}
                    />
                  )}
            </Stack>

          </Stack>
          
        )}
      {activeTab === "Video" && (
        <Box 
        sx={{ 
          width: { xs: '100%', md: '48%' }, // Full width on mobile, 48% on desktop
          maxHeight: { xs: '300px', md: '400px' }, // Set max height for mobile and desktop
          marginLeft: { md: '130px' },
          paddingLeft: '0px',
          position: 'relative', // Keeps the video within bounds
          display: 'flex',
          justifyContent: 'center', // Centers video within the box
          alignItems: 'center',
          overflow: 'hidden', // Ensures content doesn't overflow
        }}
      >
        {selectedVideo ? (
          <VideoPlayer
            video={selectedVideo} // Pass the selected video ID or URL
            studioId={playListId}
            style={{
              width: '100%',
              maxWidth: '100%',
              maxHeight: '100%', // Restrict video to the container’s height
              objectFit: 'contain', // Ensures the entire video fits within the bounds
            }}
          />
        ) : (
          <Box 
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%', // Makes sure the message stays centered vertically
            }}
          >
        <Typography>Select a video from the list below</Typography>
      </Box>
    )}
  </Box>
)}
  
      {/* Content for Music Tab (Unchanged) */}
      {activeTab !== 'Video' && (
        <Stack className="content-box" direction="column" spacing={0} sx={{ flex: 1, marginLeft: '30px' }}>
          {/* Title */}
          <Typography 
            className="__header_extra_bold title-with-icon" 
            sx={{ display: 'inline-flex', alignItems: 'center', fontSize: '24px', fontWeight: '700' }}
          >
            {title || t("myMusic.title")}
            <img src={StudIcon} alt="stat-icon" style={{ marginLeft: '10px', height: '30px' }} />
          </Typography>
  
          {/* Playlist Info */}
          <Box className="playlist-info" sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Typography className="song-count">{`${music.length} Songs`}</Typography>
            <Typography className="duration">{getTotalDuration(music)}</Typography>
          </Box>
  
          {/* Uploader Info */}
          <Stack className="uploader-info" direction="row" alignItems="center" spacing={1}>
            <Avatar
              src={createdByDetails?.profileImg?.filePath || Images.dummy1}
              alt={createdByDetails?.displayArtistName}
              sx={{ width: 20, height: 20 }}
            />
            <Typography className="uploader-name">
              {createdByDetails?.displayArtistName || "Unknown Artist"}
            </Typography>
          </Stack>
  
          {/* Buttons: Music, Share, Analytics, Tip, Live, Upload */}
          <Stack className="actions-row" direction="row" gap="10px" alignItems="center" sx={{ marginTop: '10px' }}>
            {/* Music Button */}
                   {/* Video Button */}
          <IconButton
            className="Video-button"
            onClick={() => history.push(`/app/video-player/${playListId}`)}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '40px',
              height: '40px',
              backgroundColor: '#000000',
              '&:hover': {
                backgroundColor: '#f0f0f0',
              },
            }}
          >
            <img
              src={Movie}
              alt="video"
              style={{ width: '20px', height: '20px' }}
            />
          </IconButton>
  
            {/* Share Button */}
            <IconButton className="share-button" onClick={() => setShowShareMenu(!showShareMenu)}>
              <img src={copypclip} alt="copy" style={{ width: '30px', height: '30px' }} />
            </IconButton>
  
            {/* Analytics Button */}
            {playListId && (
              <IconButton
                className="analytics-button"
                sx={{ width: "40px", height: "40px" }}
                color="default"
                onClick={() => history.push(`/app/PlaylistStatics/${playListId}/${createdBy}`)}
              >
                <img src={Trendup} alt="analytics" style={{ width: '30px', height: '30px' }} />
              </IconButton>
            )}
  
            {/* Tip Button */}
            {playListId && (
              <IconButton className="tip-button" title="Tip studio" onClick={() => setOpenTip(true)}>
                <img src={tipcolor} alt="tip" style={{ width: '30px', height: '30px', marginTop: '3px' }} />
              </IconButton>
            )}
  
            {/* Live Streaming Button */}
            {isOwnerId(owner) && !live && playListId && !nftDetails?.onAuction && !nftDetails?.onSale ? (
              <IconButton className="_playlist_streaming_camera" onClick={() => setIsStreamingPopup(true)}>
                <img title="Open live streaming" style={{ width: "20px", marginTop: '3px' }} src={Images.streaming_filled} alt="camera" />
              </IconButton>
            ) : !isOwnerId(owner) && playListId && live ? (
              <IconButton className="_playlist_streaming_camera" onClick={() => handleJoin()}>
                <img title="Open live streaming" style={{ width: "20px", marginTop: '3px' }} src={Images.streaming_filled} alt="camera" />
              </IconButton>
            ) : null}
  
            {/* Upload Video Button (only if the current user is the owner) */}
            {isOwnerId(owner) && (
              <Box sx={{ marginBottom: '3px', marginLeft: '2' }}>
                <IconButton
                  variant="contained"
                  color="primary"
                  onClick={() => setShowUploadPopup(true)}
                  sx={{
                    padding: 0,  // Remove padding to make the button fit the image size exactly
                    minWidth: 'auto',  // Prevent the button from having default minimum width
                  }}
                >
                  <img
                    src={Images.upload_home}
                    alt="Upload Video"
                    style={{
                      width: '20px',
                      height: '20px',
                    }}
                  />
                </IconButton>
              </Box>
            )}
            {/* UploadVideoPopup integration */}
            {isOwnerId(owner) && (
                    <UploadVideoPopup
                      open={showUploadPopup}
                      onClose={() => setShowUploadPopup(false)}
                      studioId={playListId}  // Pass the playlist ID as the studio ID for the upload
                      onSuccess={(data) => console.log('Video uploaded successfully', data)}
                      onError={(error) => console.error('Video upload failed', error)}
                    />
                  )}
          </Stack>
        </Stack>
      )}
  
  {playListId && (
  <div className="tipper-streamer-section" style={{ marginLeft: 'auto', marginRight: '20px' }}>
    {/* Dropdown for selecting Tippers or Streamers */}
    <DropDown
      _class="_playlist_topfive_dropdown_container"
      onChange={({ key }) => {
        if (key === "text1") {
          fetchTopFiveTippers(playListId);
        } else {
          getTopFiveMostStreamed(playListId);
        }
        setTipOrStream(t(`dropDown.${key}`));
        setMenuKey(key);
      }}
      title={tipOrStream}
      menuKey={menuKey}
      values={[
        { key: "text1", value: t("dropDown.text1") }, // Most Tippers
        { key: "text2", value: t("dropDown.text2") }, // Most Streamers
      ]}
    />

    <div className="tipper-streamer-list">
      {/* Display Streamers if menuKey is "text2" */}
      {menuKey === "text2" && topFiveStreamers.length > 0 ? (
        topFiveStreamers.map((streamer, index) => (
          <Card className="streamer-card" key={index}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Avatar
                className="avatar"
                src={streamer?.profilePic?.filePath || Images.dummy1}
                alt={streamer?.fullName || "Unknown User"}
              />
              <Typography
                className="name"
                onClick={() => history.push(`/app/ArtistProfile/${streamer._id}`)}
              >
                {streamer?.fullName || "Unknown User"}
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" className="amount-wrapper">
              <img
                src={musicnote}
                alt="stream-icon"
                style={{
                  width: '8px',
                  marginRight: '5px',
                  filter: 'invert(74%) sepia(95%) saturate(361%) hue-rotate(359deg) brightness(102%) contrast(101%)',
                }}
              />
              <Typography className="amount">
                {kFormatter(streamer?.streamCount || 0)}
              </Typography>
            </Stack>
          </Card>
        ))
      ) : menuKey === "text1" && topFiveTippers.length > 0 ? (
        /* Display Tippers if menuKey is "text1" */
        topFiveTippers.map((tipper, index) => (
          <Card className="tipper-card" key={index}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Avatar
                className="avatar"
                src={tipper.profileImg || Images.dummy1}
                alt={tipper.fullName || "Unknown User"}
              />
              <Typography
                className="name"
                onClick={() => history.push(`/app/ArtistProfile/${tipper.id}`)}
              >
                {tipper.fullName || "Unknown User"}
              </Typography>
            </Stack>
          </Card>
        ))
      ) : (
        /* Fallback when no data is available */
        <Typography className="no-data-message">No data available.</Typography>
      )}
    </div>
  </div>
      )}
    </Stack>
  );
  
  
  
  
  
  
  
  
  
}


MusicDetailsCard.propTypes = {
  activeTab: PropTypes.string.isRequired,
  video: PropTypes.object,
  music: PropTypes.array,
  playListId: PropTypes.string,
  title: PropTypes.string,
  fullName: PropTypes.func,
  t: PropTypes.func,
  listens: PropTypes.number,
  owner: PropTypes.string,
  setOpenTip: PropTypes.func,
  playAll: PropTypes.func,
  handleClick: PropTypes.func,
  option: PropTypes.bool,
  isOwnerId: PropTypes.func,
  createdBy: PropTypes.string,
  tipOrStream: PropTypes.string,
  setTipOrStream: PropTypes.func,
  menuKey: PropTypes.string,
  setMenuKey: PropTypes.func,
};

export default MusicDetailsCard;
